import React, { useState } from 'react';

interface ThumbnailImageProps {
  image: any;
  index: number;
  tag?: string;
  selectedImageIndex: number;
  handleGoTo: (index: number) => void;
}

const ThumbnailImage = React.forwardRef<HTMLImageElement, ThumbnailImageProps>(
  ({ image, index, tag, selectedImageIndex, handleGoTo }, ref) => {
    const isSelected = selectedImageIndex === index;
    const [hasError, setHasError] = useState(false);

    const sharedStyles: React.CSSProperties = {
      height: isSelected ? '95%' : '80%',
      aspectRatio: '16 / 9',
      border: isSelected ? '1.5px solid red' : '1px solid transparent',
      borderRadius: 4,
      cursor: 'pointer',
    };

    return !hasError && image ? (
      <img
        ref={ref}
        src={image}
        alt={`Selector ${index}`}
        onClick={() => handleGoTo(index)}
        onError={() => setHasError(true)}
        draggable={false}
        style={{
          ...sharedStyles,
          objectFit: 'cover',
        }}
      />
    ) : (
      <div
        onClick={() => handleGoTo(index)}
        draggable={false}
        style={{
          ...sharedStyles,
          backgroundColor: 'white',
          color: '#666',
          fontSize: '0.75rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 500,
          textAlign: 'center',
          padding: '4px',
        }}
      >
        <div>No Thumbnail</div>
        {tag && <div style={{ marginTop: 1, fontSize: '0.75rem', color: '#aaa' }}>{tag}</div>}
      </div>
    );
  }
);

export default ThumbnailImage;
